import { useMe } from '../components/AuthGate'

// Platform roles come from Kanidm groups: admin (owner), sysadmin
// (operator), user (reader). customer: only customer/project roles.
// The server checks every request; the UI only hides what a role cannot do.
export interface Can {
  role: string
  roleLabel: string
  staff: boolean // has a platform role (operator area)
  canWrite: boolean // super or operator: create, change, start jobs
  isSuperAdmin: boolean // local accounts, deleting customers
  canAdminister: boolean // users & roles, audit log
  readOnly: boolean
}

export function roleLabel(role: string): string {
  switch (role) {
    case 'admin':
      return 'Owner'
    case 'sysadmin':
      return 'Operator'
    case 'user':
      return 'Reader'
    case 'customer':
      return 'Customer user'
    default:
      return role
  }
}

export const SCOPED_ROLES: { value: 'customer-admin' | 'project-admin' | 'project-member' | 'project-reader'; label: string; scope: 'customer' | 'project'; hint: string }[] = [
  { value: 'customer-admin', label: 'Customer manager', scope: 'customer', hint: 'project manager in all projects of the customer, may create projects' },
  { value: 'project-admin', label: 'Project manager', scope: 'project', hint: 'full view of the project, members, access and resources within the quotas' },
  { value: 'project-member', label: 'Project member', scope: 'project', hint: 'works with the resources, creates servers within the quota, deletes own' },
  { value: 'project-reader', label: 'Project reader', scope: 'project', hint: 'reads the project' },
]

export const scopedRoleLabel = (r: string) => SCOPED_ROLES.find((x) => x.value === r)?.label || r

export function useCan(): Can {
  const me = useMe()
  const role = me?.role || ''
  const canWrite = role === 'admin' || role === 'sysadmin'
  return {
    role,
    roleLabel: roleLabel(role),
    staff: canWrite || role === 'user',
    canWrite,
    isSuperAdmin: role === 'admin',
    canAdminister: canWrite,
    readOnly: !canWrite,
  }
}
